<template>
<div class="chapter">
<div class="inner_page">
<div class="titleplage">
<p class="immagine3"><span>Jane Gardam</span></p>
<p class="immagine4"><span>FAITH FOX</span></p>
<div class="immagine"><img alt="" height="92" src="Images/logo.jpg" width="98"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?443e1011